module.exports = __webpack_public_path__ + "resources/img/logo_bugs.1f5355e4d3c8ee0d5a9d874fc30c633f.png";